const urlIsAbsolute = (href) => {
    const regex = /^(?:[a-z+]+:)?\/\//i;
    return regex.test(href);
};

export {
    urlIsAbsolute
};
